// trial balance than can render a table listing all accounts and their credit and debit balances
import React, { useEffect, useState } from "react";
import { useAccountingReports } from "../../../contextjs/AccountingReportsContext";
import { Card, Table, Button, Form, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../UserContext";
import { fetchStores } from "../../../api/api";

const TrialBalanceReport = () => {
    const { trialBalanceData, fetchTrialBalance } = useAccountingReports();
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [stores, setStores] = useState([]);
    const [storeId, setStoreId] = useState("all");
    const navigate = useNavigate();
    const { user } = useUser();
    const canFilterStore = Boolean(user?.is_superuser || user?.is_staff);

    const handleBack = () => {
        navigate(-1);
    };

    const handleFetch = () => {
        fetchTrialBalance(startDate, endDate, undefined, canFilterStore ? storeId : undefined);
    };

    useEffect(() => {
        fetchTrialBalance(undefined, undefined, undefined, canFilterStore ? storeId : undefined);
    }, [fetchTrialBalance, storeId, canFilterStore]);

    useEffect(() => {
        if (!canFilterStore) return;
        fetchStores()
            .then((data) => setStores(Array.isArray(data) ? data : (data?.results || [])))
            .catch((error) => console.error("Error loading stores", error));
    }, [canFilterStore]);

    if (!trialBalanceData) {
        return <p>Loading...</p>;
    }

    const { trial_balance, total_debits, total_credits } = trialBalanceData;

    return (
        <div>
            <div className="back-button-container" >
                <Button variant="secondary" onClick={handleBack}>Back</Button>
            </div>
            <Card className="mt-4">
                <Card.Header className="text-center">
                    <h2>Trial Balance</h2>
                    {startDate && endDate ? (
                        <p>For the period {startDate} to {endDate}</p>
                    ) : (
                        <p>As of {new Date().toLocaleDateString()}</p>
                    )}
                    {trialBalanceData?.scope && (
                        <p className="mb-0">{trialBalanceData.scope.effective_store_name}</p>
                    )}
                </Card.Header>
                <Card.Body>
                    {/*date range inputs*/}
                    <Form className="mb-3">
                        <Row className="align-items-end">
                            <Col xs={12} sm={4} md={4} lg={3}>
                                <Form.Group controlId="startDate">
                                    <Form.Label>Start Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={4} md={4} lg={3}>
                                <Form.Group controlId="endDate">
                                    <Form.Label>End Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            {canFilterStore && (
                                <Col xs={12} sm={4} md={4} lg={3}>
                                    <Form.Group controlId="storeScope">
                                        <Form.Label>Store</Form.Label>
                                        <Form.Select value={storeId} onChange={(e) => setStoreId(e.target.value)}>
                                            <option value="all">All Stores</option>
                                            {stores.map((store) => (
                                                <option key={store.id} value={store.id}>{store.name}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            )}
                            <Col xs={12} sm={4} md={4} lg={3}>
                                <Button variant="primary" onClick={handleFetch} className="mt-2 mt-sm-0 btn-block">Fetch</Button>
                            </Col>
                        </Row>
                    </Form>

                    {/*trial balance table*/}
                    <Table bordered hover>
                        <thead>
                            <tr>
                                <th>Account Number</th>
                                <th>Account Name</th>
                                <th className="text-right">Debit (KES)</th>
                                <th className="text-right">Credit (KES)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {trial_balance.map((account, index) => (
                                <tr key={index}>
                                    <td>{account.account_number}</td>
                                    <td>{account.account_name}</td>
                                    <td className="text-right">
                                        {account.debit !== 0 ? parseFloat(account.debit).toLocaleString() : ""}
                                    </td>
                                    <td className="text-right">
                                        {account.credit !== 0 ? parseFloat(account.credit).toLocaleString() : ""}
                                    </td>
                                </tr>
                            ))}
                            {/*totals*/}
                            <tr>
                                <td colSpan="2"><strong>Total</strong></td>
                                <td className="text-right"><strong>{total_debits.toLocaleString()}</strong></td>
                                <td className="text-right"><strong>{total_credits.toLocaleString()}</strong></td>
                            </tr>
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </div>
    );

};

export default TrialBalanceReport;